import { Outlet, useLocation, useNavigate } from 'react-router-dom';
import { useState, useCallback, useEffect } from 'react';
import BottomNav from '@/components/home/BottomNav';

const TAB_ROUTES: Record<string, string> = {
  home: '/',
  discover: '/discover',
  messages: '/messages',
  profile: '/profile',
};

const ROUTE_TO_TAB: Record<string, string> = {
  '/': 'home',
  '/discover': 'discover',
  '/messages': 'messages',
  '/profile': 'profile',
};

// Prefetch remaining lazy route chunks after layout mounts
function usePrefetchRoutes() {
  useEffect(() => {
    const schedule = (fn: () => void) => {
      if ('requestIdleCallback' in window) {
        (window as any).requestIdleCallback(fn, { timeout: 5000 });
      } else {
        setTimeout(fn, 1000);
      }
    };
    schedule(() => {
      import('@/pages/CreatePost');
      import('@/pages/PostDetail');
      import('@/pages/DailyFortune');
      import('@/pages/AstroProfile');
      import('@/pages/AstroProfileList');
      import('@/pages/EditProfile');
      import('@/pages/Invitation');
      import('@/pages/Points');
      import('@/pages/MyPosts');
      import('@/pages/LikesAndBookmarks');
      import('@/pages/BrowseHistory');
      import('@/pages/SocialConnections');
      import('@/pages/UserProfile');
      import('@/pages/MyLikers');
      import('@/pages/AiTarot');
      import('@/pages/VideoFeed');
    });
  }, []);
}

const MainLayout = () => {
  const location = useLocation();
  const activeTab = ROUTE_TO_TAB[location.pathname] || 'home';

  usePrefetchRoutes();

  return (
    <>
      <Outlet />
      <BottomNav active={activeTab} onChange={() => {}} />
    </>
  );
};

export default MainLayout;
